import React, { ReactNode } from 'react';
import Avatar from '../Avatar';
import Text from '../Text';
import withSkeleton from '../../hoc/withSkeleton';
import CardContainer from '../CardContainer';
import InfoCardSkeleton from './InfoCardSkeleton';
import Wrapper from '../Wrapper';
import './InfoCard.less';

export type InfoCardType = {
  id?: string;
  imageSrc?: string;
  image?: string;
  title: string | ReactNode;
  avatarName?: string;
  description?: string;
  actions?: ReactNode;
  indicator?: ReactNode;
  subject?: string | ReactNode;
  subjectFontWeight?: 'bold' | 'semiBold';
  disableTitleHover?: boolean;
  moreInfo?: ReactNode;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
  highlighted?: boolean;
};

type InfoCardTypeProps = {
  data: InfoCardType;
};

const TInfoCard: React.FC<InfoCardTypeProps> = ({ data }) => {
  const {
    title = '',
    avatarName = '',
    description = '',
    imageSrc = '',
    image = '',
    subject = '',
    actions,
    indicator,
    subjectFontWeight = 'bold',
    disableTitleHover = false,
    moreInfo,
    onClick = () => {},
  } = data;

  const subjectFontWeightProps =
    subjectFontWeight === 'bold'
      ? { bold: true }
      : subjectFontWeight === 'semiBold'
      ? { semiBold: true }
      : {};

  function renderInfoCard() {
    return (
      <div className="t-info-card-container" onClick={onClick}>
        {!!imageSrc && (
          <div className="t-info-imgSrc-wrapper">
            <img src={imageSrc} />
          </div>
        )}
        {!!image ? (
          <div className="t-info-img-wrapper">
            <Avatar size="xxxl" textLevel={4} src={image} />
          </div>
        ) : (
          !!avatarName && (
            <div className="t-info-img-wrapper">
              <Avatar name={avatarName} size="xxxl" textLevel={4} />
            </div>
          )
        )}
        <div className="t-info-wrapper">
          <Wrapper>
            {!!title && (
              <Text hover={!disableTitleHover} rows={1} bold>
                {title}
              </Text>
            )}
            {moreInfo && (
              <Wrapper display="flex" textAlign="center" py={3}>
                {moreInfo}
              </Wrapper>
            )}
            {!!subject && typeof subject === 'string' ? (
              <div className="t-subject-wrapper">
                <Text
                  {...subjectFontWeightProps}
                  rows={1}
                  level={3}
                  textColor="dark-50"
                >
                  {subject}
                </Text>
              </div>
            ) : (
              subject
            )}
          </Wrapper>
          {!!description && (
            <Text level={3} rows={2}>
              {description}
            </Text>
          )}
        </div>
      </div>
    );
  }

  return (
    <CardContainer highlighted={data.highlighted} bordered10>
      <div className="t-info-card-main-container">
        {renderInfoCard()}
        <Wrapper
          display="flex"
          alignItems="end"
          flexDirecton="column"
          justifyContent="space-between"
          ml={1}
        >
          {!!actions && (
            <Wrapper display="inline" justifyContent="center" pt={3}>
              {actions}
            </Wrapper>
          )}
          {!!indicator && (
            <Wrapper display="inline" justifyContent="center">
              {indicator}
            </Wrapper>
          )}
        </Wrapper>
      </div>
    </CardContainer>
  );
};

export default withSkeleton(TInfoCard, InfoCardSkeleton);
